export default {
  nav: {
    home: 'Home',
    technology: 'Technology',
    products: 'Products',
    quality: 'Quality',
    sales: 'Sales',
    customers: 'Customers',
    about: 'About',
    contact: 'Contact'
  },
  home: {
    hero: {
      title: 'Looking for a machine parts supplier?',
      subtitle: 'With over a decade of deep diving into the automation industry, we are rooted in China and globally oriented.',
      btnDetails: 'In Details',
      btnAbout: 'About Us'
    },
    products: {
      actuators: 'Pneumatic Actuators',
      controllers: 'Pneumatic Controllers',
      accessories: 'Pneumatic Accessories',
      emotion: 'E-Motion products',
      machineParts: 'Machine Parts',
      solutions: 'Customized Solutions'
    },
    contact: {
      title: 'CONTACT US',
      getStarted: 'Get Started'
    }
  },
  products: {
    title: 'Products Center',
    subtitle: 'High-quality products to meet diverse needs',
    categories: {
      all: 'All Products',
      actuators: 'Pneumatic Actuators',
      accessories: 'Pneumatic Accessories',
      controllers: 'Pneumatic Controllers',
      parts: 'Machine Parts'
    },
    items: {
      actuator: {
        name: 'Pneumatic Actuator'
      },
      controller: {
        name: 'Pneumatic Controller'
      },
      accessories: {
        name: 'Pneumatic Accessories'
      },
      solutions: {
        name: 'Customized Solutions'
      },
      emotion: {
        name: 'E-Motion Products'
      },
      machineParts: {
        name: 'Machine Parts'
      }
    }
  },
  contact: {
    title: 'Contacts',
    breadcrumb: {
      industrialParts: 'Gyre Industrial Mechanical parts',
      actuators: 'Pneumatic Actuators',
      controllers: 'Pneumatic Controllers',
      solutions: 'Customized Solutions',
      current: 'Contacts'
    },
    heading: 'CONTACT US',
    email: 'hemu@gyansol.com',
    whatsapp: '+86 13357553736',
    tel: 'TEL:',
    phone: '+8619290808990',
    promise: 'We promise to provide an efficient response on every working day.'
  },
  footer: {
    description: 'Leading Pneumatic Components Brand',
    links: {
      products: 'Products',
      solutions: 'Solutions',
      about: 'About Us'
    },
    copyright: '© 2025 GYRE CMS. All Rights Reserved.'
  },
  common: {
    loading: 'Loading...',
    noData: 'No data available',
    error: 'Operation failed',
    retry: 'Retry',
    save: 'Save',
    cancel: 'Cancel',
    confirm: 'Confirm'
  },
  notFound: {
    title: '404',
    subtitle: 'Page Not Found',
    description: 'The page you are looking for does not exist.',
    backHome: 'Back to Home'
  },
  technology: {
    hero: {
      title: 'Technology Innovation',
      subtitle: 'Leading industry technology development and providing excellent solutions'
    },
    items: {
      smartManufacturing: {
        title: 'Smart Manufacturing',
        description: 'Adopting advanced smart manufacturing technologies to improve production efficiency and product quality, achieving digitalization and automation of the production process.'
      },
      precisionControl: {
        title: 'Precision Control',
        description: 'High-precision control systems ensure product consistency and reliability, meeting the strictest quality standards.'
      },
      energySaving: {
        title: 'Energy Saving & Environmental Protection',
        description: 'Green manufacturing technology reduces energy consumption and emissions, achieving sustainable development goals.'
      },
      digitalTransformation: {
        title: 'Digital Transformation',
        description: 'Comprehensive digital solutions to enhance enterprise operational efficiency and market competitiveness.'
      }
    }
  },
  about: {
    hero: {
      title: 'About Us'
    },
    breadcrumb: {
      industrialParts: 'Gyre Industrial Mechanical parts',
      actuators: 'Pneumatic Actuators',
      controllers: 'Pneumatic Controllers',
      solutions: 'Customized Solutions',
      current: 'About Us'
    },
    intro: {
      text: 'We are a system integrator specialised in pneumatic, fluidic, electro-drive and automation design, serving high-end sectors such as non-standard automation, semiconductors and medical devices with tailored engineering solutions. Headquartered in Kunshan and Ningbo, our two precision-manufacturing campuses deliver niche and customised products—low-friction cylinders, scaled gas regulators, medical-grade fittings & tubing, compact manifold valves and bespoke pneumatic cabinets.'
    },
    welcome: {
      title: 'Welcome',
      contact: 'How to get in touch?',
      email: 'hemu@gyansol.com',
      tel: 'TEL:',
      phone: '+8619290808990',
      promise: 'We promise to provide an efficient response on every working day.'
    }
  }
}
